import { render, staticRenderFns } from "./DialogAddIdeaTemplate.vue?vue&type=template&id=2069c8ab"
import script from "./DialogAddIdeaTemplate.vue?vue&type=script&lang=js"
export * from "./DialogAddIdeaTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports